import { render, staticRenderFns } from "./TeamInformationDetail.vue?vue&type=template&id=5af62244"
import script from "./TeamInformationDetail.vue?vue&type=script&lang=js"
export * from "./TeamInformationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports